
























































































































































































import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import {
  faEnvelope,
  faHeadset,
  faPhone
} from '@fortawesome/free-solid-svg-icons'
import InfoContact from '~/components/car/information/InfoContactForm.vue'
import CBackToTop from '~/components/shared/configurable/CBackToTop.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import { UserType } from '~/models/user/types'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { ciInfo } from '~/icons/source/solid/info'
import { ciCalculator } from '~/icons/source/solid/calculator'
import { APP_NS } from '~/store/modules/shared/app/state'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'

export default Vue.extend({
  components: {
    CBackToTop,
    InfoContact,
    CCard
  },
  data() {
    return {
      telephones: []
    }
  },
  computed: {
    ...mapState(USER_NS, {
      userType: 'type'
    }),
    ...mapGetters(APP_NS, {
      isCar: 'isCar',
      isPlot: 'isPlot'
    }),
    ...mapDeps({ legacyUrlService: LegacyUrlService }),
    isAnon() {
      return this.userType === UserType.ANON
    },
    isGuest() {
      return this.userType === UserType.GUEST
    },
    breadcrumbs() {
      return [
        {
          text: this.$t('information')
        },
        {
          text: this.$t('contact')
        }
      ]
    },
    icons() {
      return {
        email: faEnvelope,
        phone: faPhone,
        question: faHeadset,
        ciInfo,
        ciCalculator
      }
    }
  },
  mounted() {
    if (this.isPlot) {
      return
    }

    this.$axios
      .get('/api/information/telephones/')
      .then(response => {
        this.telephones = response.data.data.telephones
      })
      .catch(error => {
        this.isLoading = false
        this.onResponseError(error, error.response.status)
      })
  },
  methods: {
    getLang() {
      return this.$i18n.locale
    }
  },
  head() {
    return {
      title: this.$t('contact')
    }
  }
})
